import React from 'react';
import styled from 'styled-components';
import { FormControlLabel, Checkbox as MUICheckbox } from '@material-ui/core';

export const Checkbox = ({
  name,
  onChange,
  label,
  checked,
  colour = 'text',
  ...props
}) => {
  return label ? (
    <FormControlLabel
      control={
        <StyledCheckbox
          name={name}
          onChange={onChange}
          checked={checked}
          colour={colour}
          {...props}
        />
      }
      label={label}
    />
  ) : (
    <StyledCheckbox
      name={name}
      onChange={onChange}
      checked={checked}
      colour={colour}
      {...props}
    />
  );
};

const StyledCheckbox = styled(MUICheckbox)`
  ${(props) => `
  &&{
    color: ${props.theme.palette[props.colour].main};
  &:checked {
    color: ${props.theme.palette[props.colour].main};
  }
}
  `}
`;
